export const INIT_POST_SHORT_URL = 'UTILS::INIT_POST_SHORT_URL';
export const RESPONSE_POST_SHORT_URL = 'UTILS::RESPONSE_POST_SHORT_URL';
export const ERROR_POST_SHORT_URL = 'UTILS::ERROR_POST_SHORT_URL';
export const CLEAR_POST_SHORT_URL = 'UTILS::CLEAR_POST_SHORT_URL';

export const CLEAR_ERRORS = 'UTILS::CLEAR_ERRORS';
